import {Component, OnInit} from '@angular/core';
import {LoginService} from "../../../services/login.service";
import {Login} from "../../../models/login";
import {Perfil} from "../../../models/perfil";
import {DialogLogoutComponent} from "../../../pages/dialogs/dialog-logout/dialog-logout.component";
import {MatDialog} from "@angular/material";
import {NgxSpinnerService} from "ngx-spinner";
import {Router} from "@angular/router";
import {GovBrService} from "../../../services/govbr.service";

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

    public static login: Login;
    public permissao_administrador: boolean = false;
    public permissao_gestor: boolean = false;
    public logado: boolean = false;
    public externo: boolean = false;

    constructor(private loginService: LoginService,
                private loadingService: NgxSpinnerService,
                private router: Router,
                private dialog: MatDialog,
                private govBrService: GovBrService) {

    }

    get login() {
        return NavBarComponent.login;
    }

    ngOnInit() {
        NavBarComponent.login = this.loginService.getAuth();
        if (NavBarComponent.login && NavBarComponent.login.txt_token) {
            this.logado = true;
            if (NavBarComponent.login.perfil == Perfil.ADMINISTRADOR && !NavBarComponent.login.flg_externo) {
                this.permissao_administrador = true;
            } else if (NavBarComponent.login.perfil == Perfil.GESTOR && !NavBarComponent.login.flg_externo) {
                this.permissao_gestor = true;
            }
        }
    }

    sair(): void {
        let dialog: any = this.dialog.open(DialogLogoutComponent, {width: '400px'});
        dialog.afterClosed().subscribe((result: any) => {
            let pode_sair: boolean = result.sair;
            if (pode_sair) {
                this.govBrService.logout();
                //this.router.navigateByUrl("/logout/" + this.login.perfil);
            }
        });
    }
}
